<template>
  <div>
    <div>
      <span>คอร์สที่มี หมวดหมู่คอร์ส นี้</span>
    </div>
    <div
      style="height : 300px;border : gray solid 1px; border-radius : 5px 5px 5px 5px;"
      class="p-3 my-2"
    >
      <div v-for="t in tagged" v-bind:key="t.c_id" class="my-2">
        <span>{{ t.c_name }} </span>
      </div>
    </div>
    <div style="float:right">
      <b-button variant="secondary" class="mt-2 m-1 p-2" @click="closeModal()"
        >ยกเลิก</b-button
      >
      <b-button variant="danger" class="mt-2 m-1 p-2" @click="submit()"
        >ลบ หมวดหมู่คอร์ส</b-button
      >
    </div>
  </div>
</template>

<script>
import api from '@/services/api.js';
export default {
  props: ['tag', 'id', 'course'],
  data() {
    return {
      newTag: null,
      result: {},
      apiRoute: `/v1/tags/delete-tag`,
      errorText: null,
      tagged: [],
    };
  },
  methods: {
    closeModal() {
      this.$bvModal.hide('delete-tag-' + this.id);
    },
    async submit() {
      let data = {
        tag_id: this.id,
      };
      await api
        .delete(this.apiRoute, data)
        .then(() => {
          this.$bvToast.toast(`ลบ หมวดหมู่คอร์ส ${this.newTag} สำเร็จแล้ว`, {
            title: `สำเร็จแล้ว`,
            variant: 'success',
            solid: true,
            autoHideDelay: 5000,
          });
          setTimeout(() => {
            this.$emit('deleted');
            this.$bvModal.hide('delete-tag-' + this.id);
          }, 500);
        })
        .catch(() => {
          this.$bvToast.toast(`ลบ หมวดหมู่คอร์ส ${this.newTag} ล้มเหลว`, {
            title: `เกิดข้อผิดพลาด`,
            variant: 'danger',
            solid: true,
            autoHideDelay: 5000,
          });
        });
    },
  },
  async mounted() {
    var temp = this.tag.filter((i) => i.tagId == this.id);
    this.newTag = temp[0].tagName;
    this.tagged = this.course.filter((i) => i.tag_id == this.id);
  },
};
</script>
<style scoped></style>
